
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class AllowedDevicesGrid extends Serenity.EntityGrid<AllowedDevicesRow, any> {
        protected getColumnsKey() { return AllowedDevicesColumns.columnsKey; }
        protected getDialogType() { return AllowedDevicesDialog; }
        protected getIdProperty() { return AllowedDevicesRow.idProperty; }
        protected getInsertPermission() { return AllowedDevicesRow.insertPermission; }
        protected getLocalTextPrefix() { return AllowedDevicesRow.localTextPrefix; }
        protected getService() { return AllowedDevicesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}